import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcKrwFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M8.348 9.377l.37 1.467h1.735l.276-1.118q.183-.721.266-.98.09-.268.33-.503Q11.568 8 11.99 8q.426 0 .665.243.244.236.343.519.098.275.273.964l.276 1.118h1.745l.373-1.467q.127-.534.204-.77.076-.242.259-.42.181-.187.525-.187.343 0 .595.275.252.276.252.649 0 .34-.217 1.029l-.263.89h.902a.75.75 0 1 1 0 1.5h-1.344l-.856 2.909q-.203.672-.316.972-.111.3-.357.535-.238.235-.658.235-.434 0-.686-.251a1.56 1.56 0 0 1-.364-.616q-.12-.364-.26-.948l-.718-2.835h-.735l-.696 2.835q-.21.9-.455 1.361-.244.454-.861.454a.97.97 0 0 1-.54-.146 1.1 1.1 0 0 1-.363-.397 3.4 3.4 0 0 1-.26-.624l-.175-.575-.849-2.908H6.08a.75.75 0 0 1 0-1.5h.912l-.26-.891Q6.5 9.208 6.5 8.923q0-.355.245-.64A.77.77 0 0 1 7.347 8q.476 0 .644.316.168.309.357 1.061m1.247 4.943-.499-1.976h.987zm4.81 0-.488-1.976h.992z",
    clipRule: "evenodd"
  }));
}
var IcKrwFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcKrwFill));

export { IcKrwFill as I };
